import getScrollbarWidth from 'react-custom-scrollbars-2/lib/utils/getScrollbarWidth';

export default getScrollbarWidth;
